/**
 * Venue facts shown on more than one site. GOOGLE_RATING_LINE must stay byte-identical to the
 * literal in client-lamirage-in/src/pages/BookingPage.tsx (pinned there by maisonPages.test.ts);
 * a test asserts BookingPage still contains it, so the copies cannot drift.
 */
export const GOOGLE_RATING_LINE = "★ 4.5 · 1,220 Google reviews";
export const EVENTS_LINE = "1000+ events since 2022";

/** LA Mirage Koratty's Google Maps place (owner 2026-10-20). The location QR codes encode exactly this URL. */
export const GOOGLE_MAPS_PLACE_URL = "https://www.google.com/maps?cid=1469654264509270844";
/** QR images served by la-mirage.in (client-lamirage-in/public). The PNG is for WhatsApp (no SVG there). */
export const LOCATION_QR_SVG_PATH = "/assets/location/maps-qr.svg";
export const LOCATION_QR_PNG_URL = "https://la-mirage.in/assets/location/maps-qr.png";
